import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, HelpBlock, Radio, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';

export class IntervalForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            interval: this.props.interval,
            beginInputError: null,
            endInputError: null,
            typeInputError: null
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { interval } = this.state;

        interval[property] = e;

        this.setState({
            interval: interval
        });
    }

    onSave() {
        if (this.validInput()) {
            const { interval } = this.state;
            this.props.onSave(interval);
        }
    }

    validInput() {
        let errors = 0;
        let beginInputError = null;
        let endInputError = null;
        let typeInputError = null;

        const { interval } = this.state;

        if ("" === interval.begin || null === interval.begin || undefined === interval.begin) {
            beginInputError = 'error';
            errors++;
        }

        if (interval.end < interval.begin && "" !== interval.end && undefined !== interval.end) {
            endInputError = 'error';
            errors++;
        }

        if ("" === interval.type || null === interval.type || undefined === interval.type) {
            typeInputError = 'error';
            errors++;
        }

        this.setState({
            beginInputError: beginInputError,
            endInputError: endInputError,
            typeInputError: typeInputError
        })

        return errors > 0 ? false : true;
    }

    // -------------------

    render() {
        const { title } = this.props;
        const { interval, beginInputError, endInputError, typeInputError } = this.state;

        if (undefined === interval || null === interval) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="beginDate" validationState={beginInputError}>
                            <ControlLabel>Data de Início</ControlLabel>
                            <DatePicker
                                id="beginDatePicker"
                                dateFormat="YYYY/MM/DD"
                                value={interval.begin}
                                placeholder="Introduza a Data de Início"
                                onChange={(e) => this.onChangeValue(e, 'begin')} />

                            {beginInputError !== null ?
                                <HelpBlock> Valor de data inválido. Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="endDate" validationState={endInputError}>
                            <ControlLabel>Data de Fim</ControlLabel>
                            <DatePicker
                                id="endDatePicker"
                                dateFormat="YYYY/MM/DD"
                                value={interval.end}
                                placeholder="Introduza a Data de Fim"
                                onChange={(e) => this.onChangeValue(e, 'end')} />

                            {endInputError !== null ?
                                <HelpBlock> Valor de data inválido. Verifique que a data não é anterior à data inicial. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="type" validationState={typeInputError}>
                            <ControlLabel>Tipo de Periodo</ControlLabel>
                            <Radio key={0}
                                checked={0 === interval.type}
                                onChange={(e) => this.onChangeValue(0, 'type')} >
                                Ativo
                                </Radio>

                            <Radio key={1}
                                className="padding-top-7"
                                checked={1 === interval.type}
                                onChange={(e) => this.onChangeValue(1, 'type')} >
                                Inativo
                                </Radio>
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/intervals/IntervalForm.js